import './custom_assignments' // Defines ALL (window-)global custom vars/consts: ensure to correctly overwrite below
import { overwriteColors } from './colors_enwitec'
import { overwriteCoreuiDeviceIcons, overwriteIcons } from './icons_enwitec'

const EXTERNAL_LINKS = ['enwitec.eu']
window.LegacyApp.EXTERNAL_LINKS = EXTERNAL_LINKS

overwriteColors()
overwriteIcons()
overwriteCoreuiDeviceIcons()
